import PropTypes from 'prop-types';
import React from 'react';
import { imageConfig } from './imageConfig';
import ImageDebug from './ImageDebug';
import useImage from './useImage';

const Image = React.forwardRef(function Image({ alt = 'Image', loading = 'lazy', showDebug = false, sizeMax = 0, sizes = undefined, src = undefined, ...props }, ref) {
  const { imageSrc, imageSrcSet, sizesString, fallbackUrl, srcset, handleImageError } = useImage({
    sizeMax,
    sizes,
    src,
  });

  return (
    <>
      <img
        {...props}
        ref={ref}
        alt={alt}
        loading={loading}
        onError={handleImageError}
        sizes={sizesString}
        src={imageSrc}
        srcSet={imageSrcSet}
      />

      {showDebug && <ImageDebug config={imageConfig} fallbackUrl={fallbackUrl} sizesString={sizesString} srcset={srcset} url={src} />}
    </>
  );
});

Image.propTypes = {
  alt: PropTypes.string,
  loading: PropTypes.oneOf(['lazy', 'eager']),
  showDebug: PropTypes.bool,
  sizeMax: PropTypes.oneOf([0, 50, 400, 800, 1280]),
  sizes: PropTypes.string,
  src: PropTypes.string,
};

export default Image;
